export default {"src":"/_next/static/media/heart-cat.9761266c.svg","height":52,"width":52,"blurWidth":0,"blurHeight":0};